import { useParams } from 'react-router-dom';

import { BreadcrumbItem, Link } from '@eluve/components';

export const OverviewBreadcrumbItem = () => {
  const { tenantId } = useParams() ?? {};

  return (
    <BreadcrumbItem className="hidden sm:block">
      <Link to={`/organizations/${tenantId}/home`}>Overview</Link>
    </BreadcrumbItem>
  );
};
